const LOCAL_KEY = 'language';

class LanguageManager {
  constructor(languages, defaultLanguage) {
    this.languages = languages;
    this.defaultLanguage = defaultLanguage;

    this.active = defaultLanguage;
    this.listeners = [];

    this.setLanguage(this.determineInitLanguage());
  }

  isValidLanguage(lang) {
    return Object.keys(this.languages).indexOf(lang) !== -1;
  }

  addEventListener(cb) {
    this.listeners.push(cb);
    cb(this.active);

    // unsubscribe
    return () => {
      this.listeners = this.listeners.filter(listener => listener !== cb);
    };
  }

  setLanguage(language) {
    if (this.isValidLanguage(language) && language !== this.language) {
      this.active = language;

      window.localStorage.setItem(LOCAL_KEY, language);

      this.notifyListeners();
    }
  }

  notifyListeners() {
    this.listeners.forEach(listener => listener(this.active));
  }

  determineInitLanguage() {
    const localLanguage = window.localStorage.getItem(LOCAL_KEY);

    let browserLanguage = navigator.language || navigator.userLanguage;

    if(browserLanguage) {
      browserLanguage = String(browserLanguage).substring(0, 2);
    }

    return localLanguage || browserLanguage;
  }
}

export default LanguageManager;
